import { useState } from "react";
import { Instagram } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

export default function SiteFooter() {
  const [email, setEmail] = useState("");
  const [state, setState] = useState("idle");

  const submit = async (e) => {
    e.preventDefault();
    if (state === "sending" || state === "done") return;
    setState("sending");
    try {
      const res = await fetch(`${API}/api/newsletter`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
      if (!res.ok) throw new Error("signup failed");
      setState("done");
    } catch {
      setState("error");
    }
  };

  return (
    <footer className="site-footer" data-testid="site-footer">
      <button
        className="sf-mark"
        data-testid="footer-brand-hall-link"
        aria-label="Go to The Hall"
        onClick={() => {
          window.location.hash = "hall";
        }}
      >
        The WOWOW Gallery
      </button>
      <div className="sf-links">
        <button
          className="sf-link"
          data-testid="footer-about-link"
          onClick={() => {
            window.location.hash = "/about";
          }}
        >
          About Us
        </button>
        <button
          className="sf-link"
          data-testid="footer-journal-link"
          onClick={() => {
            window.location.hash = "/journal";
          }}
        >
          Journal
        </button>
        <a
          href="https://www.instagram.com/the.wowow.gallery"
          target="_blank"
          rel="noopener noreferrer"
          className="sf-link"
          data-testid="instagram-link"
        >
          <Instagram size={13} strokeWidth={1.5} aria-hidden="true" /> Instagram
        </a>
        {state === "done" ? (
          <span className="sf-note" data-testid="newsletter-success-message">You're on the list.</span>
        ) : (
          <form className="sf-form" onSubmit={submit} data-testid="newsletter-form">
            <input
              type="email"
              required
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                if (state === "error") setState("idle");
              }}
              placeholder="Email for the mailing list"
              className="sf-input"
              data-testid="newsletter-email-input"
              aria-label="Email address for the mailing list"
            />
            <button
              type="submit"
              className="sf-link sf-submit"
              data-testid="newsletter-submit-button"
              disabled={state === "sending"}
              aria-label="Submit email to the mailing list"
            >
              {state === "sending" ? "…" : "→"}
            </button>
          </form>
        )}
        {state === "error" && (
          <span className="sf-note sf-error" data-testid="newsletter-error-message">
            Couldn't add that email — check it and try again.
          </span>
        )}
      </div>
    </footer>
  );
}
